const OCAdminMenus = [

  {
    icon: "calendar_month_icon",
    key: "uc.conference.calendar",
    name: "Conference Calendar",
    description: "",
    url: "home/app/",
  },
  {
    icon: "settings",
    key: "uc.conference.setting",
    name: "Conference Setting",
    description: "",
    url: "home/app/",
  },
  {
    icon: "music_video",
    key: "uc.conference.recording",
    name: "Conference Recording",
    description: "",
    url: "home/app/",
  },
 
];

export { OCAdminMenus };
